import Yup from '_zari/validation/_yup'

export default Yup.object().shape({
  datoPresupuestoNivel1: Yup.string().required(),
  datoPresupuestoNivel2: Yup.string().required(),
  datoPresupuestoNivel3: Yup.string().required()
})
